import { IEvent, IEventEntry, INotification } from '../interfaces/graph-types';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { PusherService } from './pusher.service';

@Injectable()
export class LiveFeedService {
  eventEntries$ = new BehaviorSubject<IEventEntry[]>([]);
  private allEventEntries: IEventEntry[] = [];

  // ------------------------------------------------------
  constructor(private pusherService: PusherService) {
    pusherService.notifications().subscribe(res => {
      console.warn('LiveFeedService');
      console.warn(res);
      if (res && res.data) {
        this.addEventFromNotification(res);
      }
    });
  }

  // ------------------------------------------------------
  public addEventFromNotification(notification: INotification): void {
    // make sure to only add relevant events (not 'import', etc.)
    if (
      notification.type === 'open' ||
      notification.type === 'click' ||
      notification.type === 'unsubscribe'
    ) {
      const {
        candidate_id,
        candidate_name,
        candidate_score,
        avatar_url,
        ...rest
      } = notification.data;
      const event: IEvent = {
        type: notification.type,
        time: notification.time,
        count: 1,
        data: rest,
      };

      const lastEntry = this.allEventEntries[0] || null;
      if (lastEntry && lastEntry.candidate_id === candidate_id) {
        const dupIndex = lastEntry.events.findIndex(
          e => JSON.stringify(e.data) === JSON.stringify(event.data),
        );
        if (dupIndex > -1) {
          event.count += lastEntry.events[dupIndex].count;
          lastEntry.events.splice(dupIndex, 1);
        }
        lastEntry.events.unshift(event);
      } else {
        const newEntry: IEventEntry = {
          id: `${this.allEventEntries.length}`,
          candidate_id,
          candidate_name,
          candidate_score,
          avatar_url,
          events: [event],
        };
        this.allEventEntries.unshift(newEntry);
      }
      this.eventEntries$.next(this.allEventEntries);
    }
  }
}
